// extracted by css-extract-rspack-plugin
export default {"refwrapper":"src-components-global-transaction-details-refrance-transaction-style-module__refwrapper-aLZa2V","title":"src-components-global-transaction-details-refrance-transaction-style-module__title-jKndZy","refrancetrans":"src-components-global-transaction-details-refrance-transaction-style-module__refrancetrans-9tBsSW","key":"src-components-global-transaction-details-refrance-transaction-style-module__key-iZlIcT","label":"src-components-global-transaction-details-refrance-transaction-style-module__label-F7hI7z"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"refwrapper\":\"src-components-global-transaction-details-refrance-transaction-style-module__refwrapper-aLZa2V\",\"title\":\"src-components-global-transaction-details-refrance-transaction-style-module__title-jKndZy\",\"refrancetrans\":\"src-components-global-transaction-details-refrance-transaction-style-module__refrancetrans-9tBsSW\",\"key\":\"src-components-global-transaction-details-refrance-transaction-style-module__key-iZlIcT\",\"label\":\"src-components-global-transaction-details-refrance-transaction-style-module__label-F7hI7z\"}";
        // 1793798895100
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  